import React from 'react';
import PDF from '../../../Components/PDF'

function QuickestAscent() {
  return (
    <div style={{ height: '100vh' }}>
      <PDF file='/quickestascent.pdf'/>
    </div>
  );
}

export default QuickestAscent;
